import React from 'react';
import  GlobalDBNPRegistriesBasicInfoComponent from './global-dbnp-registries-basic-info.component';
import  GlobalDBNPRegistriesGSTInfoComponent from './global-dbnp-registries-gst-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { DbnpRegistriesPanInfoComponent } from './global-dbnp-registries-pan-info.component';
import GlobalRegistriesKeypairInfoComponent from './global-dbnp-registries-keypair-info.component';
import GlobalCatalogInfoComponent from './global-catalog-info.component';
import GlobalOrgRegistryInfoComponent from './global-org-registry-info.component';
import GlobalDBNPMappingsInfoComponent from './global-dbnp-mappings-info.component';
import GlobalOrgRegistryMappingsInfoComponent from './global-org-registry-mappings-info.component';
import GlobalLogisticInfoComponent from '../containers/global-logistics-info.component';

function GlobalDBNPRegistriesComponent ({ 
  id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbnpRegistry 
}: any) {
  const label = selectedDbnpRegistry?.DBNIEName?.toUpperCase() || "";
    const tabItems=[
        {
            id:1,
            title:'Global DBNP Registry',
            component: <GlobalDBNPRegistriesBasicInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
            dbnpname={dbnpname}
            opsnumber={opsnumber}
            subDomains={subDomains}
            domains={domains}
            countries={countries}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'GST',
            component: <GlobalDBNPRegistriesGSTInfoComponent 
            handleInnerFormChange={handleInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
            isVisible:true,
        },
        {
            id:3,
            title:'PAN',
            component: <DbnpRegistriesPanInfoComponent
            handleInnerFormChange={handleInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
        />,
        isVisible:true,
        },
        {
            id:4,
            title:'KeyPair',
            component: <GlobalRegistriesKeypairInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
           isVisible:id > 0 ? true : false,
        },
        {
          id: 5,
          title: 'Global Org Registry',
          component: <GlobalOrgRegistryInfoComponent
          />,
          isVisible: true,
        },
        {
          id: 5,
          title: 'Global DBNP Mappings',
          component: <GlobalDBNPMappingsInfoComponent
          />,
          isVisible: true,
        },
        {
          id: 5,
          title: 'Global Org Registry Mappings',
          component: <GlobalOrgRegistryMappingsInfoComponent
          />,
          isVisible: true,
        },
        {
          id: 5,
          title: 'Global Catalog',
          component: <GlobalCatalogInfoComponent
          />,
          isVisible: true,
        },
       {
                  id:6,
                  title:`Global Logistics Catalogue`,
                  component: <GlobalLogisticInfoComponent
                  // selectedDbnpRegistry={selectedDbnpRegistry}
                 />,
                 isVisible:true,
              },
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
     <div className="w-full flex justify-start mt-10">
  <button
    type="button"
    className="text-white font-bold py-2 px-4 rounded shadow-md hover:shadow-lg transition-all uppercase"
    style={{
      backgroundColor: '#003366', // Dark blue
    }}
  >
    {label}
  </button>
</div>
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           {/* <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button> */}
      </div>
     </div>
  );
}
export default GlobalDBNPRegistriesComponent;
